"use client";
import { InteractionType } from "@/components/interactions/interactions";
import { Modal } from "@/components/modal";

interface RemoveInteractionModalProps {
  isOpen: boolean;
  interaction: InteractionType;
  onOpenChange: (isOpen: boolean) => void;
  onAccept: () => void;
}

export function RemoveInteractionModal({
  isOpen,
  interaction,
  onOpenChange,
  onAccept,
}: RemoveInteractionModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={"Aviso"}
      closeButton={{ label: "Não" }}
      buttons={[{ label: "Sim", onClick: onAccept }]}
    >
      <div>
        {interaction === "votar" &&
          "Gostaria de retirar seu voto deste problema?"}
        {interaction === "acompanhar" &&
          "Gostaria de deixar de acompanhar este problema?"}
      </div>
    </Modal>
  );
}
